import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import APP_ROUTES from '../../constants/app-routes';

import sslImage from '../../images/ssl.png';
import secImage from '../../images/secconn.png';
import privImage from '../../images/privacy.png';

class Footer extends Component {
    render() {
        const { intl } = this.props;

        return (
            <footer className="footer-section">
                <div className="footer-container">
                    <div className="links-block">
                        <div className="health-message">
                            <FormattedMessage id="smoking-harms-health" defaultMessage="Health authorities warn: smoking harms health." />
                            <FormattedMessage id="alcohol-abuse" defaultMessage="Alcohol abuse is harmful to health. eat in moderation." />
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="column col-xs-12 col-sm-12 hidden-md hidden-lg">
                                    <div className="column-inner">
                                        <ul className="list-unstyled share">
                                            <li className="title title-xs">
                                                <FormattedMessage id="follow-us" defaultMessage="follow us" />
                                            </li>
                                            <li className="social-net">
                                                <a href="#">
                                                    <i className="icon-facebook">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.76 14.94">
                                                            <g>
                                                                <g>
                                                                    <path
                                                                        /* eslint-disable-next-line max-len */
                                                                        d="M7.32,8.13l.34-2.66H5V3.77C5,3,5.25,2.48,6.35,2.48H7.76V.1a18.74,18.74,0,0,0-2-.1A3.2,3.2,0,0,0,2.29,3.51v2H0V8.13H2.29v6.82H5V8.13Z"
                                                                    />
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </i>
                                                </a>
                                            </li>
                                            <li className="social-net">
                                                <a href="#">
                                                    <i className="icon-instagram">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.01 13">
                                                            <g>
                                                                <g>
                                                                    <path
                                                                        /* eslint-disable-next-line max-len */
                                                                        d="M1.67,0h9.67A1.67,1.67,0,0,1,13,1.67v9.67A1.67,1.67,0,0,1,11.34,13H1.67A1.67,1.67,0,0,1,0,11.34V1.67A1.67,1.67,0,0,1,1.67,0Zm7.8,1.44A.59.59,0,0,0,8.89,2v1.4A.59.59,0,0,0,9.47,4h1.47a.59.59,0,0,0,.59-.59V2a.59.59,0,0,0-.59-.59ZM11.54,5.5H10.39a3.8,3.8,0,0,1,.17,1.12,4,4,0,0,1-4,3.92,4,4,0,0,1-4-3.92A3.82,3.82,0,0,1,2.64,5.5H1.45V11a.52.52,0,0,0,.52.52H11a.52.52,0,0,0,.52-.52Zm-5-1.56A2.57,2.57,0,0,0,3.9,6.47,2.57,2.57,0,0,0,6.52,9,2.57,2.57,0,0,0,9.13,6.47,2.57,2.57,0,0,0,6.52,3.94Z"
                                                                    />
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="column col-xs-5 col-sm-5 hidden-md hidden-lg">
                                    <div className="column-inner">
                                        <ul className="list-unstyled">
                                            {/* <li>
                                                <Link to={APP_ROUTES.about}>
                                                    <FormattedMessage id="about-katapulk" defaultMessage="About" />
                                                </Link>
                                            </li> */}
                                            <li>
                                                <Link to={APP_ROUTES.frequentQuestions}>
                                                    <FormattedMessage id="frequent-questions" defaultMessage="Frecuent Questions" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="column col-xs-7 col-sm-7 hidden-md hidden-lg">
                                    <div className="column-inner">
                                        <ul className="list-unstyled">
                                            <li>
                                                <Link to={APP_ROUTES.policy}>
                                                    <FormattedMessage id="privacy-policy" defaultMessage="Privacy Policy" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={APP_ROUTES.returns}>
                                                    <FormattedMessage id="return-policy" defaultMessage="Return Policy" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={APP_ROUTES.shipping}>
                                                    <FormattedMessage id="shipping-and-rates" defaultMessage="Shipping & Rates" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={APP_ROUTES.terms}>
                                                    <FormattedMessage id="term-and-conditions" defaultMessage="Terms & Conditions" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="column col-md-2 hidden-md hidden-lg">
                                    <div className="column-inner" style={{ marginTop: '15px' }}>
                                        <ul className="list-unstyled">
                                            <li>
                                                <a href="mailto:info@cubalicores.com">
                                                    <FormattedMessage id="info-cubalicores" defaultMessage="info@cubalicores.com" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="column col-md-2 col-md-offset-2 hidden-sm hidden-xs">
                                    <div className="column-inner">
                                        <p className="title">
                                            <FormattedMessage id="my-account" defaultMessage="My Account" />
                                        </p>
                                        <ul className="list-unstyled">
                                            <li>
                                                <Link to={APP_ROUTES.terms}>
                                                    <FormattedMessage id="term-and-conditions" defaultMessage="Terms & Conditions" />
                                                </Link>
                                            </li>
                                            {/* <li>
                                                <Link to={APP_ROUTES.offers}>
                                                    <FormattedMessage id="bids-and-offers" defaultMessage="Bids and Offers" />
                                                </Link>
                                            </li> */}
                                            <li>
                                                <Link to={APP_ROUTES.frequentQuestions}>
                                                    <FormattedMessage id="frequent-questions" defaultMessage="Frecuent Questions" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                {/* <div className="column col-md-2 hidden-sm hidden-xs">
                                    <div className="column-inner">
                                        <p className="title">
                                            <FormattedMessage id="about-us" defaultMessage="About Us" />
                                        </p>
                                        <ul className="list-unstyled">
                                            <li>
                                                <Link to={APP_ROUTES.about}>
                                                    <FormattedMessage id="about-katapulk" defaultMessage="About" />
                                                </Link>
                                            </li>
                                            <li>
                                                <FormattedMessage id="contact" defaultMessage="Contact" />
                                            </li>
                                        </ul>
                                    </div>
                                </div> */}
                                <div className="column col-md-2 hidden-sm hidden-xs">
                                    <div className="column-inner">
                                        <p className="title">
                                            <FormattedMessage id="customer-service" defaultMessage="Customer Service" />
                                        </p>
                                        <ul className="list-unstyled">
                                            <li>
                                                <Link to={APP_ROUTES.policy}>
                                                    <FormattedMessage id="privacy-policy" defaultMessage="Privacy Policy" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={APP_ROUTES.returns}>
                                                    <FormattedMessage id="return-policy" defaultMessage="Return Policy" />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to={APP_ROUTES.shipping}>
                                                    <FormattedMessage id="shipping-and-rates" defaultMessage="Shipping & Rates" />
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="column col-md-2 hidden-sm hidden-xs">
                                    <div className="column-inner">
                                        <p className="title hidden-xs">
                                            <FormattedMessage id="follow-us" defaultMessage="follow us" />
                                        </p>
                                        <ul className="list-unstyled share">
                                            <li className="social-net">
                                                <a href="" target="_blank">
                                                    <i className="icon-facebook">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.76 14.94">
                                                            <g>
                                                                <g>
                                                                    <path
                                                                        /* eslint-disable-next-line max-len */
                                                                        d="M7.32,8.13l.34-2.66H5V3.77C5,3,5.25,2.48,6.35,2.48H7.76V.1a18.74,18.74,0,0,0-2-.1A3.2,3.2,0,0,0,2.29,3.51v2H0V8.13H2.29v6.82H5V8.13Z"
                                                                    />
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </i>
                                                </a>
                                            </li>
                                            <li className="social-net">
                                                <a href="#" target="_blank">
                                                    <i className="icon-instagram">
                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.01 13">
                                                            <g>
                                                                <g>
                                                                    <path
                                                                        /* eslint-disable-next-line max-len */
                                                                        d="M1.67,0h9.67A1.67,1.67,0,0,1,13,1.67v9.67A1.67,1.67,0,0,1,11.34,13H1.67A1.67,1.67,0,0,1,0,11.34V1.67A1.67,1.67,0,0,1,1.67,0Zm7.8,1.44A.59.59,0,0,0,8.89,2v1.4A.59.59,0,0,0,9.47,4h1.47a.59.59,0,0,0,.59-.59V2a.59.59,0,0,0-.59-.59ZM11.54,5.5H10.39a3.8,3.8,0,0,1,.17,1.12,4,4,0,0,1-4,3.92,4,4,0,0,1-4-3.92A3.82,3.82,0,0,1,2.64,5.5H1.45V11a.52.52,0,0,0,.52.52H11a.52.52,0,0,0,.52-.52Zm-5-1.56A2.57,2.57,0,0,0,3.9,6.47,2.57,2.57,0,0,0,6.52,9,2.57,2.57,0,0,0,9.13,6.47,2.57,2.57,0,0,0,6.52,3.94Z"
                                                                    />
                                                                </g>
                                                            </g>
                                                        </svg>
                                                    </i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="column col-md-2 hidden-sm hidden-xs">
                                    <div className="column-inner">
                                        <p className="title hidden-xs">
                                            <FormattedMessage id="contact" defaultMessage="contact" />
                                        </p>
                                        <ul className="list-unstyled">
                                            <li>
                                                <a href="mailto:info@cubalicores.com">
                                                    <FormattedMessage id="info-cubalicores" defaultMessage="info@cubalicores.com" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="row text-center margin-top-50">
                                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <ul className="list-inline">
                                        <li>
                                            <img
                                                src={sslImage}
                                                alt={intl.formatMessage({
                                                    id: 'secure-checkout',
                                                    defaultMessage: 'Secure Checkout',
                                                })}
                                            />
                                        </li>
                                        <li>
                                            <img
                                                src={secImage}
                                                alt={intl.formatMessage({
                                                    id: 'secure-connection',
                                                    defaultMessage: 'Secure Connection',
                                                })}
                                            />
                                        </li>
                                        <li>
                                            <img
                                                src={privImage}
                                                alt={intl.formatMessage({
                                                    id: 'privacy-protected',
                                                    defaultMessage: 'Privacy Protected',
                                                })}
                                            />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mini-footer-block">
                        <div className="primary-brand pull-left" />
                        <div className="break-left" />
                        <div className="break-right" />
                        <div className="secondary-brand" />
                        <div className="copyright">
                            <p>
                                <FormattedMessage id="copyright" defaultMessage="Copyright" />
                            </p>
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default injectIntl(Footer);



/** WEBPACK FOOTER **
 ** ./src/components/shared/footer.jsx
 **/